module.exports = __webpack_public_path__ + "static/media/energy_icon.b24e6315.svg";